// assets
import AssessmentIcon from '@mui/icons-material/Assessment';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import BusinessIcon from '@mui/icons-material/Business';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

// type
import ERoutes from 'routes/ERoutes';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - REPORTING ||============================== //

const reporting: NavItemType = {
    id: 'reporting',
    title: 'Reporting',
    icon: AssessmentIcon,
    type: 'group',
    url: ERoutes.reportingBusinesses,
    children: [
        {
            id: 'reporting-businesses',
            title: 'Pogozo businesses',
            type: 'item',
            icon: BusinessIcon,
            url: ERoutes.reportingBusinesses,
            breadcrumbs: false
        },
        {
            id: 'reporting-sales',
            title: 'Pogozo sales report',
            type: 'item',
            icon: TrendingUpIcon,
            url: ERoutes.reportingSalesReport,
            breadcrumbs: false
        },
        {
            id: 'reporting-communication-reports',
            title: 'Communication reports',
            type: 'item',
            icon: ForwardToInboxIcon,
            url: ERoutes.reportingCommunicationReports,
            breadcrumbs: false
        },
        {
            // POGO-13862 (A2): the Onboarding report now lives at its own
            // /reporting/onboarding route so the SubNav resolves it to the
            // Reporting group instead of bleeding the Business tab bar.
            id: 'business-onboarding',
            title: 'Onboarding report',
            type: 'item',
            icon: AssignmentTurnedInIcon,
            url: ERoutes.reportingOnboarding,
            breadcrumbs: false
        },
        {
            id: 'crm-reporting',
            title: 'Customer journey report',
            type: 'item',
            icon: AltRouteIcon,
            url: ERoutes.crmReporting,
            breadcrumbs: false
        }
    ]
};

export default reporting;
